import React from 'react';

const DownloadSampleCsv = (props) => {
     return (
        <button className='btn btn_green' onClick={ () => props.aacDownloadSampleCsvAction() }>Download Sample CSV</button>
     )
}

export default DownloadSampleCsv;